"use client";

import { Button, Flex, Input } from "@chakra-ui/react";
import { useRouter } from "next/navigation";
import { useCallback, useState } from "react";
import { LuSearch } from "react-icons/lu";

interface TrackingSearchFormProps {
  defaultValue?: string;
}

const TrackingSearchForm = ({ defaultValue }: TrackingSearchFormProps) => {
  const router = useRouter();
  const [value, setValue] = useState(defaultValue ?? "");
  const [submitting, setSubmitting] = useState(false);

  const onChangeValue = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setValue(e.target.value.toUpperCase());
    },
    [],
  );

  const onSubmit = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      const trimmed = value.trim();
      if (trimmed.length === 0) {
        return;
      }
      setSubmitting(true);
      router.push(`/track/${encodeURIComponent(trimmed)}`);
    },
    [router, value],
  );

  return (
    <form onSubmit={onSubmit} style={{ width: "100%" }}>
      <Flex gap={2} w="100%">
        <Input
          size="sm"
          placeholder="e.g. ELK1234ABCD"
          borderColor="border.light"
          _placeholder={{ color: "text.secondary" }}
          value={value}
          onChange={onChangeValue}
          aria-label="Tracking number"
        />
        <Button
          type="submit"
          size="sm"
          loading={submitting}
          disabled={value.trim().length === 0}
        >
          <LuSearch />
          Track
        </Button>
      </Flex>
    </form>
  );
};

export default TrackingSearchForm;
